<!-- Loading Spinner -->
<ng-container *ngIf="isLoading$ | async">
  <div class="progress progress-modal">
    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
         role="progressbar" style="width: 100%" aria-valuenow="100"
         aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
</ng-container>

<!-- Page Title Section -->
<div class="page-title-area page-title-four">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="page-title-item">
        <h2>{{ page == 1 ? ('MENU.Board' | translate) : ('MENU.BoardOfDirectors' | translate) }}</h2>
        <ul>
          <li><a routerLink="/about">{{ 'MENU.ABOUTUS' | translate }}</a></li>
          <li><i class="icofont-simple-right"></i></li>
          <li>{{ page == 1 ? ('MENU.Board' | translate) : ('MENU.BoardOfDirectors' | translate) }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Team Section -->
<section class="doctors-area doctors-area-two pt-100">
  <div class="container-fluid py-5 px-lg-5">

    <!-- First Row - single member alone -->
    <div class="row justify-content-center">
      <div class="col-md-6 col-sm-6 mb-4">
        <ng-container *ngTemplateOutlet="teamCard; context: { $implicit: BoardTeams[0] }"></ng-container>
      </div>
    </div>

    <!-- Second Row - next two members -->
    <div class="row justify-content-center">
      <div
        class="col-md-6 col-sm-6 mb-4"
        *ngFor="let member of BoardTeams.slice(1, 3)">
        <ng-container *ngTemplateOutlet="teamCard; context: { $implicit: member }"></ng-container>
      </div>
    </div>

    <!-- Third Row - remaining members -->
    <div class="row justify-content-center">
      <div
        class="col-md-4 col-sm-6 mb-4"
        *ngFor="let member of BoardTeams.slice(3)">
        <ng-container *ngTemplateOutlet="teamCard; context: { $implicit: member }"></ng-container>
      </div>
    </div>

  </div>
</section>

<!-- Reusable Team Card Template -->
<ng-template #teamCard let-member>
  <div class="card team-card text-center shadow border-0 h-100 rounded-4 p-3">
    <img [src]="member.image" alt="{{member.name}}" class="rounded-circle team-photo mx-auto mb-3 shadow-sm">
    <h2 class="fw-semibold my-4">
      {{ language === 'en' ? member.nameEn : member.nameAr }}
    </h2>
    <h4 class="text-muted mb-1" >
      {{ language === 'en' ? member.titleEn : member.titleAr }}
    </h4>
    <p class="text-body-secondary px-2 my-3"
       style="--tw-text-opacity: 1;color: rgb(147 147 147 / var(--tw-text-opacity))!important; text-align: justify;">
      {{ language === 'en' ? member.bioEn : member.bioAr }}
    </p>
  </div>
</ng-template>
